module.exports = __webpack_public_path__ + "img/lg_ring_y_i_null_null.0d113a3b.png";